export default __webpack_public_path__ + "static/media/cif-sa.11214682.svg";